import { makeStyles, shorthands } from '@fluentui/react-components';

export const useVideoCardContainerStyle = makeStyles({
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    ...shorthands.gap('8px'),
    flexDirection: 'row',
    maxWidth: '75%',
  },
});
